const calculateInterval = ({ data, oneOff }) => {
    if (!data || data.length === 0) return 0;
    if (data.length <= 7 && !oneOff) return 0;
    if (data.length <= 7 && oneOff) return 1;
    if (data.length > 7 && data.length < 20) return 1;
    if (data.length > 20 && data.length < 200) return 15;
    if (data.length > 200) return 40;
    return 0;
};

export const calculateLineInterval = () => {
    return "preserveStartEnd";
};

export default calculateInterval;
